/* eslint import/prefer-default-export: 0 */
import CenterColumn from './CenterColumn';

export default {
  CenterColumn,
};
